export const columns = [
    {
        title: "Product",
        links: [
            { label: "Overview", href: "/get-started" },
        ],
    },
    {
        title: "Company",
        links: [
            { label: "About", href: "https://emtech.com/about-us" },
            { label: "Case Studies", href: "https://emtech.com/resources/case-studies" }
        ],
    },
    {
        title: "Resources",
        links: [
            { label: "API Reference", href: "/apis" },
            { label: "Status", href: "https://status.emtech.com" },
            { label: "Contact Us", href: "https://emtech.com/contact-us" },
        ],
    },
    {
        title: "Legal",
        links: [
            { label: "Terms", href: "https://emtech.com/terms-&-conditions" }
        ],
    },
]
